import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useNavigate } from "react-router-dom";
import { addDoc, collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { getFirebaseDocs, randomString } from '../common'
import Header from '../components/Header'
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";

const Entertainment = () => {

    const [isAdding, setIsAdding] = useState(false)
    const [editId, setEditId] = useState('')
    const [name, setName] = useState('')
    const [priority, setPriority] = useState('')
    const [audio, setAudio] = useState('')

    const [loading, setLoading] = useState(false)
    // const [mode, setMode] = useState(modes[0])
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [parentsCategories, setParentsCategories] = useState([])
    // const [coachCategories, setCoachCategories] = useState([])

    const userInfo = useSelector(state => state.user.user)


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            fetchCategories()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        console.log('userData', userData)
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
        // fetchCategories()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const fetchCategories = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `entertainment-categories`), orderBy('priority', 'desc'))))
        setParentsCategories(docs)
    }


    const saveEntertainmentCategory = async () => {

        if (editId) {
            await setDoc(doc(db, 'entertainment-categories', editId), { name, audio: audio || '', priority: parseInt(priority) })

        } else {
            await addDoc(collection(db, 'entertainment-categories'), { name, audio: audio || '', priority: parseInt(priority) })
        }
        setIsAdding(false)
        setEditId('')
        fetchCategories()
    }

    return <div className="container">
        <Header />
        <>
            {isAdding && <>
                <h2>Add an Entertainment Category</h2>
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'priority'} value={priority} setValue={setPriority} label={'Priority'} />

                <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio</label>
                <MyDropzone storageLocation={`Categories/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audio} updateImage={(doc) => setAudio(doc)} />


                <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                    <button disabled={!name || !priority || !parseInt(priority)} onClick={saveEntertainmentCategory}>Save</button>
                    <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAdding(false); setEditId('') }}>Cancel</button>
                </div>
            </>}

            {!isAdding && <>
                <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAdding(true); setEditId('') }}>+ Add New</button>
                <h2>Entertainment Categories</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Priority
                            </th>
                            <th>
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {parentsCategories.map(({ id, name, priority, audio }) => <tr key={id}>
                            <td>
                                {name}
                            </td>
                            <td>
                                {priority}
                            </td>
                            <td>
                                <div style={{ display: 'flex' }}>
                                    <button className="textButton" onClick={() => navigate(`/entertainmentActivity?category=${id}`)}>View</button>
                                    <button className="textButton" onClick={() => { setIsAdding(true); setPriority(priority); setEditId(id); setName(name); setAudio(audio) }}>Edit</button>
                                </div>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </>}

        </>
    </div>
}

export default Entertainment